import { stateName } from './constants';

const localState = state => state[stateName];

export const getIsFeatureSwitchEnabled = name => state => localState(state)[name] || false;